import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { AuthShell } from "./LoginPage";
import { TID } from "@/constants/testIds";
import { toast } from "sonner";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Si le compte existe, un e-mail a été envoyé.");
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail));
    }
    setLoading(false);
  };
  return (
    <AuthShell>
      <h1 className="font-serif text-3xl sm:text-4xl">Mot de passe oublié ?</h1>
      <p className="mt-2 text-muted-foreground">Nous vous enverrons un lien de réinitialisation.</p>
      {!sent ? (
        <form onSubmit={onSubmit} className="mt-8 space-y-4">
          <div>
            <Label htmlFor="mail">Adresse e-mail</Label>
            <Input id="mail" data-testid={TID.forgotEmail} type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5" />
          </div>
          {error && <div className="rounded-xl border border-destructive/30 bg-destructive/5 px-4 py-3 text-sm text-destructive">{error}</div>}
          <Button type="submit" disabled={loading} className="btn-pill w-full" data-testid={TID.forgotSubmit}>
            {loading ? "Envoi…" : "Envoyer le lien"}
          </Button>
        </form>
      ) : (
        <div className="mt-8 rounded-xl border border-border bg-secondary/50 p-6 text-sm">
          Vérifiez votre boîte de réception. Si l'adresse est associée à un compte, vous recevrez un lien sécurisé pour réinitialiser votre mot de passe.
        </div>
      )}
      <p className="mt-6 text-sm text-muted-foreground text-center">
        <Link to="/login" className="text-accent link-underline">Retour à la connexion</Link>
      </p>
    </AuthShell>
  );
}
